import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Intervention,
  RequestLineStatus,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}TechnicalIntervention/bydates`;

interface GetTechnicalInterventionsByDatesQueryPayload {
  sellerId: string;
  startTime?: string;
  endTime?: string;
  siteIds?: string[];
  technicianIds?: string[];
  pieceStatuses?: RequestLineStatus[];
}

const getTechnicalInterventionsByDatesQuery = async ({
  sellerId,
  startTime,
  endTime,
  siteIds,
  technicianIds,
  pieceStatuses,
}: GetTechnicalInterventionsByDatesQueryPayload): Promise<
  BackResponse<Intervention[]> | BackResponseFailure
> => {
  const url = buildUrl(ENDPOINT, {
    sellerId,
    startTime,
    endTime,
    siteIds,
    technicianIds,
    filterRequestLineStatuses: pieceStatuses,
  });

  try {
    return await apiCall<BackResponse<Intervention[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getTechnicalInterventionsByDatesQuery;
